<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFolderAlertOutline } from "@mdi/js";
export default {
  name: "MdiFolderAlertOutline",
  data() {
    return {
      svgPath: mdiFolderAlertOutline,
    };
  },
};
</script>
